import dayjs, { Dayjs } from "dayjs";

export const disabledPastDate = (current: Dayjs) => {
  return current && current.isBefore(dayjs().startOf("day")); // Disable dates before today
};
